export default __webpack_public_path__ + "static/media/icons-subscribe-checked.ccd1cde2.svg";